( function ($) {

    $('.child .child-action').on('click', function (event) {
        event.preventDefault();

        const $child = $(this).parents('.child');
        $child.toggleClass('is-editing');
    });

    $('.child-create .child-action').on('click', function (event) {
        event.preventDefault();

        const $child = $(this).parents('.child-create');

        $child.toggle();
        $child.find('.wrap-input input').val('');
    });

    $('.add-child').on('click', function (event) {
        event.preventDefault();

        $('.child-create').show();
    });

    const $deleteChildModal = $('#delete-child');

    $('.delete-child').on('click', function (event) {
        event.preventDefault();

        const childUuid = $(this).data('uuid');

        $deleteChildModal.on('shown.bs.modal', function () {
             $deleteChildModal.find('input.child-uuid').val(childUuid);
        });

        $deleteChildModal.modal('show');
    });

}(jQuery));
